import { render } from "./BilletRemovalConfirmationDialog.vue?vue&type=template&id=61cfdc36"
import script from "./BilletRemovalConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./BilletRemovalConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__